import * as React from "react";
import classnames from "classnames";
import { useConfiguratorContext } from "../../../../Context/Context/ConfiguratorContext.js";
import { usePrivateSteppingContext } from "../../../../Context/Context/PrivateSteppingContext.js";
import { ExpanderContainer } from "../Expander/components/Footer/components/Expander/ExpanderContainer.js";
import { TopBar } from "../TopBar/components/Footer/components/TopBar/TopBar.js";
/* empty css                        */
const ConfiguratorFooter = () => {
  const { isFooterOpen } = useConfiguratorContext();
  const { footerTopBarContent, footerExpanderContent } = usePrivateSteppingContext();
  return /* @__PURE__ */ React.createElement(
    "footer",
    {
      "data-t": "configurator-footer",
      className: classnames("configurator-footer", {
        "configurator-footer--summary-expanded": isFooterOpen
      })
    },
    /* @__PURE__ */ React.createElement(TopBar, null, footerTopBarContent),
    /* @__PURE__ */ React.createElement(ExpanderContainer, null, footerExpanderContent)
  );
};
export {
  ConfiguratorFooter
};
//# sourceMappingURL=ConfiguratorFooter.js.map
